import React from 'react';
import { IconButton, Box, Icon } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const HotelCardImageMap = ({
  hotel,
  hasIdFav,
  isLoadImage,
  setIsLoadImage,
  getFavConfig,
  handleImageError,
  defaultImage,
  handleCloseModal,
}) => {
  const favConfig = getFavConfig(hotel.id_fav_message);

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: '8px 8px 0 0',
        position: 'relative',
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      {/* Close button */}
      <Box sx={{ position: 'absolute', top: 8, right: 8, zIndex: 11 }}>
        <IconButton
          onClick={e => {
            e.stopPropagation();
            handleCloseModal();
          }}
          sx={{
            backgroundColor: 'rgba(255,255,255,0.8)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,1)' },
            width: 32,
            height: 32,
          }}
        >
          <CloseIcon sx={{ fontSize: 18, color: 'black' }} />
        </IconButton>
      </Box>

      {/* Imagen */}
      <Box
        component="img"
        src={hotel.main_image || defaultImage}
        onError={e => handleImageError(e, hotel.main_image)}
        onLoad={() => setIsLoadImage(true)}
        alt={hotel.name}
        sx={{
          width: '100%',
          height: { xs: '10em', sm: '9em' },
          objectFit: 'cover',
          objectPosition: 'center 10%',
          borderRadius: '8px 8px 0 0',
          display: isLoadImage ? 'block' : 'none',
        }}
      />

      {/* Placeholder si la imagen aún no cargó */}
      {!isLoadImage && (
        <Box
          sx={{
            width: '100%',
            height: { xs: '10em', sm: '9em' },
            bgcolor: 'grey.300',
            borderRadius: '8px 8px 0 0',
          }}
        />
      )}

      {/* Favorito */}
      {hasIdFav && hotel.id_fav_message && favConfig && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            px: 1,
            py: 0.5,
            borderRadius: '8px 0 0 0',
            backgroundColor: favConfig.color,
          }}
        >
          <Icon fontSize="small">{favConfig.icon}</Icon>
        </Box>
      )}
    </Box>
  );
};

export default HotelCardImageMap;
